import React from 'react';
import {
  Card,
  CardContent,
  CardImage,
  Title,
  Description,
  Meta,
} from './styles/ArticleCardStyle';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';

export interface ArticleCardProps {
  articleLink?: string;
  title: string;
  description: string;
  imageUrl: string;
  date?: string;
  readTime?: string;
  slug: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({
  articleLink,
  title,
  description,
  imageUrl,
  date,
  readTime,
}) => {
  return (
    <Card to={articleLink || ''}>
      <CardImage src={imageUrl} alt={title} />
      <CardContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Meta>
          {date ? (
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <FaCalendarAlt style={{ position: 'relative', top: '-1px' }} />
              <span>{date}</span>
            </span>
          ) : null}
          {readTime ? (
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <FaClock style={{ position: 'relative', top: '-1px' }} />
              <span>{readTime} דקות קריאה</span>
            </span>
          ) : null}
        </Meta>
      </CardContent>
    </Card>
  );
};

export default ArticleCard;
